import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';
import { GetQueryCount } from '@/infrastructure/api-functions/interface/get-query-count.interface';


export const GetQueryCountDTO = Symbol('GetQueryCountDTO');

export interface GetQueryCountDTO {
    fetch: AISearchRepository['getQueryCount'];
}

@injectable()
export class GetQueryCountDTOImpl implements GetQueryCountDTO {
    constructor(
        @inject(GetQueryCount)
        private readonly _getQueryCountApi: GetQueryCount,
    ) { }

    async fetch(value: string) {
        const res = await this._getQueryCountApi.getQueryCount({
            q: value,
            simple: true,
            search_mode: 'publication',
        });

        return res.number;
    }
}
